'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MCIcon = require('./MCIcon');

var _MCIcon2 = _interopRequireDefault(_MCIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAIcon = function (_Icon) {
    (0, _inherits3.default)(FAIcon, _Icon);

    function FAIcon() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FAIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FAIcon.__proto__ || (0, _getPrototypeOf2.default)(FAIcon)).call.apply(_ref, [this].concat(args))), _this), _this.baseClassName = 'fa', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }
    /** @override **/


    return FAIcon;
}(_MCIcon2.default);

exports.default = FAIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvaWNvbi9GQUljb24uanN4Il0sIm5hbWVzIjpbIkZBSWNvbiIsImJhc2VDbGFzc05hbWUiLCJJY29uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7Ozs7O0lBRXFCQSxNOzs7Ozs7Ozs7Ozs7OztnTkFFakJDLGEsR0FBZ0IsSTs7QUFEaEI7Ozs7RUFEZ0NDLGdCOztrQkFBZkYsTSIsImZpbGUiOiJGQUljb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IEljb24gZnJvbSAnLi9NQ0ljb24nO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBGQUljb24gZXh0ZW5kcyBJY29uIHtcbiAgICAvKiogQG92ZXJyaWRlICoqL1xuICAgIGJhc2VDbGFzc05hbWUgPSAnZmEnO1xufVxuXG4iXX0=